import api from "@/lib/api";
function H() {
  const c = document.cookie.split(";").map(x=>x.trim()).find(x=>x.startsWith("active_hotel_id="));
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return { headers: v ? { "X-Hocp-Hotel": v } : {} };
}
export const hkInvAPI = {
  dashboard: () => api.get("/hkinv/v1/dashboard", H()).then(r => r.data),
  items:     () => api.get("/hkinv/v1/items", H()).then(r => r.data),
  createItem: (b) => api.post("/hkinv/v1/items", b, H()).then(r=>r.data),
  updateItem: (id, b) => api.patch(`/hkinv/v1/items/${id}`, b, H()).then(r=>r.data),
  requests:  (params={}) => api.get("/hkinv/v1/requests", { ...H(), params }).then(r=>r.data),
  createRequest: (b) => api.post("/hkinv/v1/requests", b, H()).then(r=>r.data),
  updateRequestStatus: (id, b) => api.post(`/hkinv/v1/requests/${id}/status`, b, H()).then(r=>r.data),
  usage:     (params={}) => api.get("/hkinv/v1/usage", { ...H(), params }).then(r=>r.data),
  usageSummary: (days=14) => api.get("/hkinv/v1/usage/summary", { ...H(), params: { days } }).then(r=>r.data),
  usageTrend: (days=14) => api.get("/hkinv/v1/usage/trend", { ...H(), params: { days } }).then(r=>r.data),
  createUsage: (b) => api.post("/hkinv/v1/usage", b, H()).then(r=>r.data),
  floors:      () => api.get("/hkinv/v1/floors", H()).then(r=>r.data),
  setFloorPar: (b) => api.post("/hkinv/v1/floors/par", b, H()).then(r=>r.data),
  restockFloor:(b) => api.post("/hkinv/v1/floors/restock", b, H()).then(r=>r.data),
  consumeFloor:(b) => api.post("/hkinv/v1/floors/consume", b, H()).then(r=>r.data),
};

export const REQ_TRANSITIONS = {
  requested:   ["reviewing","approved","waiting","denied"],
  reviewing:   ["approved","waiting","denied"],
  waiting:     ["reviewing","approved","denied"],
  approved:    ["picking"],
  picking:     ["ready"],
  ready:       ["delivered"],
  delivered:   ["hk_received"],
  hk_received: ["closed"],
  closed:      [],
  denied:      [],
};
export const REQ_STATUS_LABEL = {
  requested: "Requested", reviewing: "Reviewing", waiting: "Waiting",
  denied: "Denied", approved: "Approved", picking: "Picking",
  ready: "Ready", delivered: "Delivered", hk_received: "Received", closed: "Closed",
};
export const REQ_STATUS_STYLE = {
  requested: "bg-slate-100 text-slate-700",
  reviewing: "bg-sky-100 text-sky-700",
  waiting:   "bg-amber-100 text-amber-700",
  denied:    "bg-rose-100 text-rose-700",
  approved:  "bg-emerald-100 text-emerald-700",
  picking:   "bg-violet-100 text-violet-700",
  ready:     "bg-cyan-100 text-cyan-700",
  delivered: "bg-teal-100 text-teal-700",
  hk_received: "bg-emerald-200 text-emerald-800",
  closed:    "bg-slate-200 text-slate-600",
};

export function fmtDT(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }); }
  catch { return "—"; }
}
